// extracted by mini-css-extract-plugin
export default {"appShell":"Layout_appShell__rIl8y","body":"Layout_body__AOzHb","content":"Layout_content__-XVhO"};